

// voxblock.js
import { Delegate } from "//voxblock.co.uk/cdn/shop/t/133/assets/vendor.min.js?v=52426788336887041471763741520";

// Encapsulating the module in an IIFE is not strictly necessary with ES6+ modules,
// but for the sake of direct integration into a script tag or existing build process, we'll keep functions scoped.

const VoxBlock = (() => {
    const audio = new Audio();
    audio.addEventListener('loadstart', function(){console.log('loadstart')})
    audio.addEventListener('playing', function(){console.log('playing')})
    audio.addEventListener('ended', function(){console.log('ended'); audio.currentButton.classList.remove('playing');})

    const initAudioDelegate = (selector) => {
        const delegate = new Delegate(document.body);
        delegate.on('click', selector, (event, target) => {
            const srcfile = target.getAttribute('data-mp3');
            audio.currentButton = target;
            if (!audio.src.includes(srcfile)) {
                audio.src = srcfile;
            }

            if (target.classList.contains('playing')) {
                target.classList.remove('playing');
                audio.pause();
            } else {
                document.querySelectorAll(selector).forEach(el => el.classList.remove('playing'));
                target.classList.add('playing');
                audio.play();
            }

            event.preventDefault();
        });
    };

    return {
        initAudioDelegate,
    };
})();

export default VoxBlock;

document.addEventListener('DOMContentLoaded', function() {
    VoxBlock.initAudioDelegate('.bookpreview'); // Initialize audio playback

});

